import { Injectable } from '@angular/core';
import { AuthService } from '../../api/services/auth.service';
import { PreferencesService } from '../../api/services/preferences.service';
import { NavigationButton, NavigationButtonService } from '../navigation-button/navigation-button.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class DashboardButtonsService implements NavigationButtonService {
  constructor(private auth: AuthService,
  private preferencesService: PreferencesService) { }

  buttons: NavigationButton[] = [
    {
      title: 'My Oasis',
      text: 'This shows a timeline list of your projects.',
      icon: '&#xe91b;',
      route: 'my-oasis',
      isSelected: false,
      order: 1
    },
    {
      title: 'Markets',
      text: 'Select the current active market.',
      icon: '&#xe933;',
      route: 'markets',
      isSelected: false,
      order: 2
    },
    {
      title: 'Approvals',
      text: 'View pending and closed approvals.',
      icon: '&#xe91e;',
      route: 'approvals',
      isSelected: false,
      order: 3
    },
    {
      title: 'Orders',
      text: 'Place, edit, and delete orders.',
      icon: '&#xe950;',
      route: 'orders',
      isSelected: false,
      order: 4
    },
    {
      title: 'BOMs',
      text: 'Create, Manage and Edit BOMs',
      icon: '&#xe923;',
      route: 'boms',
      isSelected: false,
      order: 5
    },
    {
      title: 'Reports',
      text: 'See Reporting for Order Status and more.',
      icon: '&#xe934;',
      route: 'reports',
      isSelected: false,
      order: 6
    },
    {
      title: 'Teams',
      text: 'Manage the various Teams and Delegations',
      icon: '&#xe937;',
      route: 'teams',
      isSelected: false,
      order: 7
    }
  ];

  getButtons(): Observable<NavigationButton[]> {
    return this.preferencesService.getPreferences('USER', this.auth.getUserId())
    .map(prefs => {
      // for a recently created user there are no preferences
      if (!prefs['dashboard-order'].Value) return this.buttons;

      const dashboardOrder = JSON.parse(prefs['dashboard-order'].Value)
      .reduce((prev, curr) => Object.assign(prev, curr), {});

      return this.buttons.map(
        b => {
          b.order = dashboardOrder[b.route];
          return b;
        })
        .sort((a, b) => a.order - b.order)
      ;
    });
  }

  setButtons(buttons: NavigationButton[]) {
    const projection = buttons.map(b => ({[b.route]: b.order}));
    this.preferencesService.setPreference('USER', this.auth.getUserId(), 'dashboard-order', {Value: JSON.stringify(projection)})
    .subscribe();
    this.buttons = buttons;
  }

  getNavigationCommands(button: NavigationButton) {
    return ['/dashboard', {outlets: {'dashboard-content': [button.route]}}];
  }

  onUrlChange(url: string, buttons: NavigationButton[]) {
    const btns = buttons;
    if (url === '/dashboard/(dashboard-content:markets)') {
      for(const btn of btns) {
        btn.isSelected = btn.route === 'markets';
      }
    }

    return btns;
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/services/dashboard-buttons.service.ts